import React, { useState, useEffect, useMemo } from "react";
import "./RoomSelection.scss";
import OwlCarousel from "react-owl-carousel2";
import "../../../../common/css/owl.carousel.css";
import LeftIcon from "../../../../common/images/chevron-left.svg";
import UserIcon from "../../../../common/images/user.svg";
import information from "../../../../common/images/info-circle.svg";
import { showPriceValue } from "../../../Helpers/SettingHelper";
import { Button } from "@mui/material";
import Accordion from "../../../../common/images/chevron-up-side-sheet.svg";

import {
  hotelGallery,
  location,
  wifi,
  blackdot,
  left,
  galleryclose,
  gallery,
} from "../../../Helpers/Images";
const staygallery = {
  items: 1,
  loop: true,
  dots: false,
  nav: true,
};

const RoomSelection = (rProps) => {
  const {
    state,
    checkRoomSelection,
    loadHotelImages,
    handleViewMoreClick,
    cancellationPolicy,
    showRoomPrice,
    selectRoom,
    setShowChooseRoom,
    continueRoom,
    selectMainRoom,
    loadRatingstar,
    loadRatingNumber,
    viewGalleries,
  } = rProps;

  const carousel = {
    items: 1,
    loop: true,
    dots: !state?.isMobile,
    nav: true,
    mouseDrag: false,
    touchDrag: false,
    navText: [
      `<img src="${left}" alt="Prev" class="prev-button"/>`,
      `<img src="${left}" alt="Next" class="next-button"  />`,
    ],
  };
  const selectedRoomPrice = {};

  const [hotelDetailsAccordion, setHotelDetailsAccordion] = useState(false);
  const [viewGallery, setViewGallery] = useState(false);
  const [selectedImage, setSelectedImage] = useState(0);
  const [imagesArray, setImagesArray] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  const [policyReadMore, setPolicyReadMore] = useState(false);
  const [amenitiesReadMore, setAmenitiesReadMore] = useState(false);
  const selectedPrice = {};
  const roomGallery = state.viewGallery;

  const accordion = () => {
    setHotelDetailsAccordion(!hotelDetailsAccordion);
  };
  const Gallery = (images) => {
    setViewGallery(true);
    processImages(images);
  };
  const processImages = (imagesString) => {
    if (!imagesString) return;
    const parsedImages = imagesString.split(", ").map((item) => {
      const parts = item.split("#@#").filter(Boolean);
      return { alt: parts[0], src: parts[1] };
    });

    setImagesArray(parsedImages);
  };
  useEffect(() => {
    if (state.viewGallery) {
      Gallery(state.hotelResult?.images);
    } else {
      processImages(state.hotelResult?.images);
    }
  }, [state.hotelResult, state.viewGallery]);

  const prevNextImage = (position) => {
    let index = selectedImage;
    if (position === "previous") {
      index = selectedImage > 0 ? selectedImage - 1 : 0;
    } else {
      index =
        selectedImage < imagesArray.length - 1
          ? selectedImage + 1
          : imagesArray.length - 1;
    }

    setSelectedImage(index);
  };

  const imageSelection = (image) => {
    setSelectedImage(image);
  };
  const toggleDescription = (readmore) => {
    if (readmore === "about") {
      setIsExpanded((prevState) => !prevState);
    } else if (readmore === "policy") {
      setPolicyReadMore((prevState) => !prevState);
    } else if (readmore === "amenities") {
      setAmenitiesReadMore((prevState) => !prevState);
    }
  };
  const amenitiesToDisplay = amenitiesReadMore
    ? state.hotel_amenities
    : state.hotel_amenities.slice(0, 3);

  const closeGallery = () => {
    viewGalleries(false);
    setViewGallery(false);
  };
  const selectedRoomPriceIndex = (item, index) => {
    const roomPriceIndex =
      state.selectedRoom?.find(
        (room) =>
          parseInt(room?.roomIndex) === parseInt(index) &&
          parseInt(room?.roomMainIndex) === parseInt(state.currentRoom)
      )?.priceIndex ?? 0;
    return showRoomPrice(item, roomPriceIndex);
  };
  const hotelImages = useMemo(
    () => loadHotelImages(state.hotelResult?.images),
    [state.hotelResult?.images]
  );

  return (
    <div className="room-selection-main">
      <div className="room-selection-main__header">
        <div className="room-selection-main__header__sub">
          <div className="room-selection-main__header__sub__col">
            <img
              src={LeftIcon}
              onClick={() => setShowChooseRoom(false)}
              alt="left"
            />
          </div>
          <div className="room-selection-main__header__sub__col1">
            <div className="room-selection-main__header__sub__col1__title">
              More Stays
            </div>
            <div className="room-selection-main__header__sub__col1__sub">
              Select the stay from available options{" "}
            </div>
          </div>
          {/* <div className="room-selection-main__header__sub__col2">
            <div>
              <img
                src={CloseIcon}
                alt="back-icon"
                className="room-selection-main__header__sub__col2__close"
                // onClick={handleCloseSheet}
              />
            </div>
          </div> */}
        </div>
        <div
          className={`hotel-detail-accordion ${
            hotelDetailsAccordion ? `accordion-border` : ""
          }`}
        >
          <div className="hotel-detail-accordion__hotelimage">
            {!hotelDetailsAccordion && (
              <div className="hotel-detail-accordion__hotelimage__image">
                <img src={state.hotelResult?.thumbnail_image} alt="hotel" />
              </div>
            )}

            <div className="hotel-detail-accordion__hotelimage__name">
              <h4 className="hotel-detail-accordion__hotelimage__name__title">
                {state.hotelResult?.hotel_name}
              </h4>
              <div className="hotel-detail-accordion__hotelimage__name__about">
                <h6>About</h6>
                <img src={blackdot} alt="hotel" />
                <h6>Hotel Policy</h6>
                <img src={blackdot} alt="hotel" />
                <h6>Photos</h6>
              </div>
            </div>
          </div>
          <div
            className="hotel-detail-accordion__arrowicon"
            onClick={() => {
              accordion();
            }}
          >
            <img
              className={`${
                hotelDetailsAccordion
                  ? "hotel-detail-accordion__arrowicon__opened"
                  : "hotel-detail-accordion__arrowicon__closed"
              }`}
              src={Accordion}
              alt="ShevronImage"
            />
          </div>
        </div>
        {hotelDetailsAccordion && (
          <div className="hotel-details">
            <div className="hotel-details__info">
              <div className="hotel-details__info__image">
                <div className="hotel-details__info__image__gallerybutton">
                  <h4
                    onClick={() => {
                      Gallery(state.hotelResult?.images);
                    }}
                  >
                    Gallery <img src={gallery} alt="gallery" />
                  </h4>
                </div>
                <OwlCarousel options={carousel}>
                  {imagesArray.map((item, index) => {
                    return <img key={index} src={item.src} alt={"gallery"} />;
                  })}{" "}
                </OwlCarousel>
              </div>
              <div className="hotel-details__info__content">
                <h4 className="hotel-details__info__content__title">
                  {state.hotelResult?.hotel_name}
                </h4>
                <div className="hotel-details__info__content__rating">
                  <div className="hotel-details__info__content__rating__number">
                    {loadRatingNumber(state.hotelResult?.rating)}
                  </div>
                  <div className="hotel-details__info__content__rating__star">
                    {loadRatingstar(state.hotelResult?.rating, "hotel")}
                  </div>
                  {/* <div className="hotel-details__info__content__rating__reviews">
                    12,12312
                  </div> */}
                </div>
                <div className="hotel-details__info__content__location">
                  <div className="hotel-details__info__content__location__icon">
                    {" "}
                    <img src={location} alt="location" />
                  </div>
                  <div className="hotel-details__info__content__location__address">
                    <h6>{state.hotelResult?.address}</h6>
                  </div>
                </div>
              </div>
              <div className="hotel-details__info__amenties">
                {amenitiesToDisplay.map((item, index) => (
                  <div
                    key={index}
                    className="hotel-details__info__amenties__image"
                  >
                    <img src={wifi} alt="wifi" />
                    <h4>{item}</h4>
                  </div>
                ))}
                {state.hotel_amenities.length > 3 && (
                  // <button
                  //   onClick={() => {
                  //     toggleDescription("amenities");
                  //   }}
                  // >
                  <div
                    onClick={() => {
                      toggleDescription("amenities");
                    }}
                    className="hotel-details__info__amenties__image"
                  >
                    <img src={wifi} alt="wifi" />
                    <h4>
                      {amenitiesReadMore
                        ? "See Less"
                        : `+${state.hotel_amenities.length - 3} more`}
                    </h4>
                  </div>
                  //   {amenitiesReadMore
                  //     ? "See Less"
                  //     : `+${state.hotel_amenities.length - 3} more`}
                  // </button>
                )}
              </div>
            </div>
            <div className="hotel-details__about">
              <h4>About</h4>
              <p>
                {isExpanded
                  ? state.hotelResult?.description1
                  : state.hotelResult?.description1.slice(0, 150) + "..."}
                <span onClick={() => toggleDescription("about")}>
                  {isExpanded ? "Read Less" : "Read More"}
                </span>
              </p>{" "}
            </div>
            {Array.isArray(state.hotelResult?.room_info) && (

            <div className="hotel-details__policy">
              <h4>Policy</h4>
              <p>
                {" "}
                {state.hotelResult?.room_info?.map((room) => {
                  return room?.map((charge) => {
                    return policyReadMore
                      ? charge?.room_charges[0].tariff_notes
                      : charge?.room_charges[0].tariff_notes.slice(0, 50) +
                          "...";
                  });
                })}
                <span onClick={() => toggleDescription("policy")}>
                  {policyReadMore ? "Read Less" : "Read More"}
                </span>
              </p>
            </div>
            )}
          </div>
        )}
        {Array.isArray(state.hotelResult?.room_info) &&
          state.hotelResult?.room_info.length > 0 && (
            <div className="room-selection-main__header__tabs">
              {state.hotelResult?.room_info?.map((item, index) => (
                <div
                  key={index}
                  id="preferred-room"
                  className={`room-selection-main__header__tabs__tab ${
                    state.currentRoom === index
                      ? "room-selection-main__header__tabs__active"
                      : ""
                  }`}
                  onClick={() => selectMainRoom(index)}
                >
                  Room 0{parseInt(index) + 1}
                </div>
              ))}
            </div>
          )}

        <div></div>
      </div>
      <div className="room-selection-main__content">
        {state?.hotelResult?.room_info && (
          <>
            {state.availableRooms === true ? (
              <>
                {/* <div className="preferred-room" id="preferred-room">
                  <ul>
                    {state.hotelResult?.room_info.map((item, index) => {
                      return (
                        <li
                          className={
                            state.currentRoom === index ? "active" : ""
                          }
                          key={index}
                        >
                          {state.roomCount > 1 && (
                            <a
                              href={void 0}
                              onClick={this.selectMainRoom.bind(this, index)}
                            >
                              Room {parseInt(index) + 1} options
                            </a>
                          )}
                        </li>
                      );
                    })}
                  </ul>
                </div> */}
                {state.hotelResult?.room_info?.map((roomItem, roomIndex) => {
                  return (
                    <ul
                      key={roomIndex}
                      style={{
                        display: state.currentRoom !== roomIndex ? "none" : "",
                      }}
                    >
                      {roomItem.map((item, index) => {
                        var checkRoomSelectionVal = checkRoomSelection(
                          index,
                          roomIndex
                        );
                        return (
                          <li
                            key={index}
                            id={"room_" + roomIndex + "_" + item.room_type_code}
                            className={
                              checkRoomSelectionVal > 0
                                ? "active room-selection-main__content__card"
                                : "room-selection-main__content__card"
                            }
                          >
                            <div className="room-selection-main__content__card__row">
                              <div className="room-selection-main__content__card__row__lhs">
                                <div className="room-parent">
                                  <div className="room-choice-img">
                                    {/* {state.currentRoom === roomIndex && (
                                      <OwlCarousel options={staygallery}>
                                        {hotelImages}
                                      </OwlCarousel>
                                    )} */}
                                    <img
                                      src={state.hotelResult?.thumbnail_image}
                                      alt="room"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="room-selection-main__content__card__row__rhs">
                                <div className="room-selection-main__content__card__row__rhs__title">
                                  {item.room_type_name}
                                </div>
                                <div className="room-selection-main__content__card__row__rhs__rmCapacity">
                                  <img src={UserIcon} alt="user" />{" "}
                                  <span className="room-selection-main__content__card__row__rhs__rmCapacity__label">
                                    Room Capacity{" "}
                                  </span>
                                  {parseInt(item.max_adult) > 0 && (
                                    <span className="room-selection-main__content__card__row__rhs__rmCapacity__pCount">
                                      {parseInt(item.max_adult)} Adult
                                      {parseInt(item.max_adult) > 1 ? "s" : ""}
                                    </span>
                                  )}
                                  {parseInt(item.max_children) > 0 && (
                                    <span className="room-selection-main__content__card__row__rhs__rmCapacity__pCount">
                                      {parseInt(item.max_children)} Child
                                      {parseInt(item.max_children) > 1
                                        ? "s"
                                        : ""}
                                    </span>
                                  )}
                                </div>

                                <div className="details-policy">
                                  <a
                                    href={void 0}
                                    onClick={() =>
                                      cancellationPolicy(item, selectedPrice)
                                    }
                                  >
                                    <img src={information} alt="info" />
                                    <span>
                                      More details on cancellation policy
                                    </span>{" "}
                                  </a>
                                </div>

                                <div className="room-selection-main__content__card__row__rhs__amenities">
                                  {item.room_amenities !== "" &&
                                    item.room_amenities !== null &&
                                    item.room_amenities
                                      ?.split("#@#")
                                      ?.slice(0, state?.isMobile ? 1 : 2)
                                      ?.map((amenity) => (
                                        <div className="room-selection-main__content__card__row__rhs__amenities__val">
                                          {amenity.charAt(0).toUpperCase() +
                                            amenity.slice(1)}
                                        </div>
                                      ))}

                                  {item.room_amenities.length > 0 && (
                                    <div
                                      className="room-selection-main__content__card__row__rhs__amenities__val room-selection-main__content__card__row__rhs__amenities__more"
                                      onClick={() =>
                                        handleViewMoreClick(
                                          "hotel_info_popup_" +
                                            roomIndex +
                                            "_" +
                                            item.room_type_code
                                        )
                                      }
                                    >
                                      +{" "}
                                      {item.room_amenities?.split("#@#")
                                        ?.length -
                                        (state?.isMobile ? 1 : 2)}{" "}
                                      more
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="room-selection-main__content__card__roomCharges">
                              {item.room_charges.length > 0 && (
                                <>
                                  <div className="room-selection-main__content__card__roomCharges__title">
                                    <img src={information} alt="info" />
                                    Select Extra Options{" "}
                                  </div>
                                  <div className="room-selection-main__content__card__roomCharges__content">
                                    <ul className="room-selection-main__content__card__roomCharges__content__chargeList">
                                      {item.room_charges.map(
                                        (chargeItem, chargeIndex) => {
                                          const selectedRoomObj =
                                            state.selectedRoom?.find(
                                              (room) =>
                                                parseInt(room.roomMainIndex) ===
                                                  parseInt(roomIndex) &&
                                                room.room_type_code ===
                                                  item.room_type_code
                                            );
                                          return (
                                            <li key={chargeIndex}>
                                              <div>
                                                <input
                                                  type="radio"
                                                  className="room_charge"
                                                  name={`room_charge_${roomIndex}_${item.room_type_code}`}
                                                  data-itemindex={chargeIndex}
                                                  value={`${chargeItem.rate_id}_${chargeIndex}`}
                                                  checked={
                                                    parseInt(
                                                      selectedRoomObj?.priceIndex
                                                    ) === chargeIndex
                                                  }
                                                  onChange={() => {
                                                    const obj = {
                                                      [item.room_type_code]: {
                                                        index: chargeIndex,
                                                        priceId:
                                                          chargeItem.rate_id,
                                                      },
                                                    };

                                                    selectRoom(
                                                      item.room_type_code,
                                                      index,
                                                      item,
                                                      roomIndex,
                                                      checkRoomSelectionVal,
                                                      state.hotelResult
                                                        .hotel_name,
                                                      obj,
                                                      false
                                                    );
                                                  }}
                                                />
                                                <span>
                                                  {chargeItem.rate_description}
                                                </span>
                                              </div>
                                              <strong>
                                                {showPriceValue(
                                                  chargeItem.room_total_amount,
                                                  state.currentCurrency,
                                                  state.currencyRate
                                                )}
                                              </strong>
                                            </li>
                                          );
                                        }
                                      )}
                                    </ul>
                                  </div>

                                  <div className="room-choice-four">
                                    <div className="rcf-lhs">
                                      <p>
                                        <strong className="selected_room_price">
                                          {selectedRoomPriceIndex(item, index)}
                                        </strong>{" "}
                                      </p>
                                      <span>Total Excludes Taxes and Fees</span>
                                    </div>
                                    {/* <div className="rcf-rhs">
                                      <button
                                        className={
                                          checkRoomSelectionVal > 0
                                            ? "button ghost-button rmv-button"
                                            : "button ghost-button"
                                        }
                                        onClick={() =>
                                          selectRoom(
                                            item.room_type_code,
                                            index,
                                            item,
                                            roomIndex,
                                            checkRoomSelectionVal,
                                            state.hotelResult?.hotel_name,
                                            selectedRoomPrice,
                                            checkRoomSelectionVal > 0
                                          )
                                        }
                                        // disabled={disableRoom(index, roomIndex)}
                                      >
                                        {checkRoomSelectionVal > 0
                                          ? "Remove"
                                          : "Select"}
                                      </button>
                                    </div> */}
                                  </div>
                                </>
                              )}
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  );
                })}
              </>
            ) : (
              state.availablemsg
            )}
          </>
        )}
      </div>
      {!state?.isMobile && (
        <div className="room-selection-main__footer">
          <div className="room-selection-main__footer__col">
            <div className="room-selection-main__footer__col__price">
              Total{" "}
              {showPriceValue(
                state.grand_total !== "" ? state.grand_total : 0,
                state.currentCurrency,
                state.currencyRate
              )}
            </div>
            <div className="room-selection-main__footer__col__breakDown">
              <span>
                {state.selectedRoom.length ? (
                  <>
                    {[...state.selectedRoom]
                      .sort((a, b) => a.roomMainIndex - b.roomMainIndex)
                      .map((item, index) => (
                        <>
                          {state.selectedRoom.length > 1 ? (
                            <span>Room {index + 1}</span>
                          ) : (
                            <span>Room Price</span>
                          )}{" "}
                          {showPriceValue(
                            item.room_total_amount,
                            state.currentCurrency,
                            state.currencyRate
                          )}
                        </>
                      ))}{" "}
                  </>
                ) : (
                  showPriceValue(0, state.currentCurrency, state.currencyRate)
                )}
              </span>
            </div>
          </div>
          <div className="room-selection-main__footer__col">
            <Button
              className={`room-selection-main__footer__col__continueBtn ${
                state.selectedRoom.length > 0
                  ? "check_room_avail"
                  : "disabled-link"
              }`}
              variant="contained"
              // disabled={state.selectedRoom.length === 0}
              onClick={() => continueRoom()}
            >
              Continue
            </Button>
          </div>
        </div>
      )}
      {(roomGallery || viewGallery) && (
        <div className="room-selection-main__hotel-details-gallery">
          <div
            onClick={() => closeGallery()}
            className="room-selection-main__hotel-details-gallery__closebutton"
          >
            {" "}
            <img src={galleryclose} alt="closeicon" />
          </div>

          <div className="room-selection-main__hotel-details-gallery__container">
            <div className="room-selection-main__hotel-details-gallery__container__fullscreen">
              {!state.isMobile && (
                <div className="room-selection-main__hotel-details-gallery__container__fullscreen__prev">
                  <img
                    onClick={() => {
                      prevNextImage("previous");
                    }}
                    src={left}
                    alt="prev-button"
                  />
                </div>
              )}

              <div className="room-selection-main__hotel-details-gallery__container__fullscreen__image">
                <OwlCarousel options={carousel}>
                  {imagesArray.map((item, index) => {
                    return (
                      <img
                        key={index}
                        src={
                          selectedImage !== ""
                            ? imagesArray[selectedImage]?.src
                            : item.src
                        }
                        alt={"gallery"}
                      />
                    );
                  })}
                </OwlCarousel>
                {state.isMobile && (
                  <img
                    className="room-selection-main__hotel-details-gallery__container__fullscreen__image__next"
                    onClick={() => {
                      prevNextImage("previous");
                    }}
                    src={left}
                    alt="prev-button"
                  />
                )}
                {state.isMobile && (
                  <img
                    className="room-selection-main__hotel-details-gallery__container__fullscreen__image__prev"
                    onClick={() => {
                      prevNextImage("next");
                    }}
                    src={left}
                    alt="next-button"
                  />
                )}
                {imagesArray.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className="room-selection-main__hotel-details-gallery__container__fullscreen__image__content"
                    >
                      <div className="room-selection-main__hotel-details-gallery__container__fullscreen__image__content__description">
                        <h4>
                          {selectedImage !== ""
                            ? imagesArray[selectedImage]?.alt
                            : item.alt}
                        </h4>
                      </div>

                      <div className="room-selection-main__hotel-details-gallery__container__fullscreen__image__content__total">
                        <h4>
                          {`${
                            selectedImage !== "" &&
                            selectedImage < imagesArray.length
                              ? selectedImage + 1
                              : imagesArray.length
                          }/${imagesArray.length}`}
                        </h4>
                      </div>
                    </div>
                  );
                })}

                {/* {imageDescription(state.hotelResult?.images)} */}
              </div>
              {!state.isMobile && (
                <div className="room-selection-main__hotel-details-gallery__container__fullscreen__next">
                  <img
                    onClick={() => {
                      prevNextImage("next");
                    }}
                    src={left}
                    alt="next-button"
                  />
                </div>
              )}
            </div>
            <div className="room-selection-main__hotel-details-gallery__container__smallscreen">
              <div
                className={`room-selection-main__hotel-details-gallery__container__smallscreen__slider `}
              >
                {imagesArray.map((item, index) => {
                  return (
                    <img
                      className={
                        selectedImage === index ? "selected_image" : ""
                      }
                      key={index}
                      onClick={() => {
                        imageSelection(index);
                      }}
                      src={item.src}
                      alt={"gallery"}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RoomSelection;
